import { apiGet } from '../../api'

export const get_recruits = query => {
  return apiGet({
    endpoint: `recruitment/get_recruits?group_id=${query}`
  })
}
